export function buildGestorDashboardTaskPath(
  taskId: number,
  params: { createdFrom?: string; createdTo?: string; squadId?: number | null },
) {
  const search = new URLSearchParams()
  if (params.createdFrom) search.set('createdFrom', params.createdFrom)
  if (params.createdTo) search.set('createdTo', params.createdTo)
  if (params.squadId) search.set('squadId', String(params.squadId))
  const query = search.toString()
  return `/gestores/dashboard/tarefa/${taskId}${query ? `?${query}` : ''}`
}

export function buildGestorDashboardBackPath() {
  return '/gestores?tab=dashboard'
}
